import { useNavigation } from '@react-navigation/native';
import { BaseText, BottomButtonsLayout, Button, Title } from 'aimo-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistoryStore } from 'stores/historyStore';
import { StyledImage, StyledWrapper } from 'styles/ContainerStyles';
import { RootNavProps } from 'types/navigation';
import { useUiStore } from 'stores/uiStore';

const AccountRestrictedModalContent: React.FC = () => {
  const { t } = useTranslation();
  const { navigate } = useNavigation<RootNavProps>();

  const navigateToUnpaidFees = () => {
    useHistoryStore.getState().setParkingHistoryViewFilter('failed');
    navigate('mainTabs', {
      screen: 'accountScreen',
      params: {
        screen: 'parkingHistory',
      },
    });
    useUiStore.getState().setSheetModal('');
  };

  const closeModal = () => {
    useUiStore.getState().setSheetModal('');
  };
  return (
    <BottomButtonsLayout
      scrollable={false}
      contentBottom={
        <>
          <StyledWrapper mb={15}>
            <Button
              testID="account-restricted-unpaid-fees-button"
              text={t('account.restricted.unpaidFees')}
              size="l"
              buttonType="secondary"
              onPress={navigateToUnpaidFees}
            />
          </StyledWrapper>
          <StyledWrapper mb={0}>
            <Button
              testID="account-restricted-close-button"
              text={t('button.close')}
              size="l"
              buttonType="tertiary"
              onPress={closeModal}
            />
          </StyledWrapper>
        </>
      }>
      <StyledWrapper mb={20}>
        <StyledImage
          testID="account-restricted-image"
          width={140}
          height={140}
          center
          source={require('assets/images/onboarding-welcome.png')}
        />
      </StyledWrapper>
      <StyledWrapper mb={30}>
        <Title center testID="c-title">
          {t('account.restricted.title')}
        </Title>
      </StyledWrapper>
      <StyledWrapper>
        <BaseText center testID="account-restricted-description">
          {t('account.restricted.description')}
        </BaseText>
      </StyledWrapper>
    </BottomButtonsLayout>
  );
};

export default AccountRestrictedModalContent;
